
  // shipping info banner
var shippingBannerCookieKey = 'seen-shipping-banner';
  
async function localLocate() {
  const req = await fetch(window.Shopify.routes.root
    + 'browsing_context_suggestions.json'
    + '?country[enabled]=true'
    + `&country[exclude]=${window.Shopify.country}`
    + '&language[enabled]=true'
    + `&language[exclude]=${window.Shopify.language}`);
  const res = await req.json();
  return res;
}

function toggleCountryPop(){
  const popup = document.querySelector('.js-country-switch-popup');
  const popOverlay = document.querySelector('.js-country-switch-popup .js-close-overlay');
  if (popup) {
    popup.classList.toggle('hidden');
    popOverlay.classList.toggle('hidden');
    popup.classList.toggle('flex');
  } else {
    console.error('Popup element not found');
  }
}

// check if in europe to check or uncheck newsletter sign up checkbox
if (document.body.classList.contains('template-customers/register')) {
  localLocate().then(res => {
    if (!('handle' in res.detected_values.country)) {
      console.log('country identification error 1');
      return;
    }
    var countryCode = res.detected_values.country.handle;

    var marketingCheckbox = document.getElementById('marketing');
    if (euCountryCodes.includes(countryCode)) {
      marketingCheckbox.checked = false;
    } else {
      marketingCheckbox.checked = true;
    }
  });
}

let actualCountry = document.querySelectorAll('.js-country-switch-actual-country');

for (let i = 0; i < actualCountry.length; i++) {
  if (theme.countryCode in restOf) {
    actualCountry[i].innerHTML = restOf[theme.countryCode];
  } else {
    actualCountry[i].innerHTML = countryCodeToCountry[theme.countryCode]; // important to have it here to cover mobile too
  }
}

// display the country selector popup when needed
var hasCheckedCountryCookie = 'checked-country';

if (document.cookie.indexOf(hasCheckedCountryCookie) == -1) {

  localLocate().then(res => {
    if (!('handle' in res.detected_values.country)) {
      console.log('country identification error 1');
      return;
    }
    var countryCode = res.detected_values.country.handle;

    if(!(theme.countryCode in countryCodeToCountry)) {
      console.log('Unknown country',theme.countryCode);
    }
    if(!(countryCode in countryCodeToCountry)) {
      console.log('Unknown country',countryCode);
    }

    var showPopup = false;
    for (var i in otherCountriesOf) {
      var otherCountries = otherCountriesOf[i];
      if (otherCountries.indexOf(countryCode) != -1) {
        showPopup = (otherCountries.indexOf(theme.countryCode) == -1);
        break;
      }
    }
    if (!showPopup) {
      if(countryCode != theme.countryCode)
        showPopup = true;
    }

    if (showPopup) {
      document.querySelector('.js-country-switch-new-country').textContent = countryCodeToCountry[countryCode];
      document.getElementById('form_country_code').value = countryCode;
      toggleCountryPop();
    } else {
      setCountryCookie(true);
    }
  });
}

document.querySelectorAll('.js-open-country-selector').forEach(element => {
  element.addEventListener('click', e => {
    e.stopPropagation();
    toggleCountryPop();
    let langSelect = document.getElementById('form_language_code');
    let countrySelect = document.getElementById('form_country_code');

    const langCookie = document.cookie.split('; ').find(row => row.startsWith(`${hasSelectedLang}=`));
    if (langCookie) {
      const selectedLang = langCookie.split('=')[1];
      langSelect.value = selectedLang;
    }

    console.log('langSelect.value', langSelect.value)
    console.log('langCookie', langCookie)

    setLangOptions(countrySelect.value);

    // Retrieve the selected language option from the session cookie
    if(!document.querySelector('.site-nav--search-overlay').classList.contains('hidden')){
      theme.SearchNav.closeSearchNav();
    }
    if(document.querySelector('.mobile-nav-wrapper').classList.contains('js-menu--is-open')){
      theme.MobileNav.closeMobileNav();
    }
  });
});

let hasSelectedLang = 'selected-lang'

function setLangOptions(cc) {
  let countryCode = cc;
  let langSelect = document.getElementById('form_language_code');
  let langOptions = langSelect.querySelectorAll('option');
  if (countryCode == 'FR') {
    langOptions.forEach(option => {
      if (option.value == 'fr' || option.value == 'en') {
        option.classList.remove('hidden');
      } else {
        option.classList.add('hidden');
      }
    })
    langSelect.classList.remove('hidden')
  } else if (countryCode == 'DE') {
    langOptions.forEach(option => {
      if (option.value == 'de' || option.value == 'en') {
        option.classList.remove('hidden');
      } else {
        option.classList.add('hidden');
      }
    })
    langSelect.classList.remove('hidden')
  }else{
    langOptions.forEach(option => {
      if (option.value != 'en') {
        option.classList.add('hidden');
      }
    })
    langSelect.classList.add('hidden')
  }
};

function setCountryCookie(sessionOnly) {
  console.log('cookie set')
  var cookieStr = hasCheckedCountryCookie + '=1;';
  if (!sessionOnly) {
    var now = new Date();
    var time = now.getTime();
    var expireTime = time + 2628000000; // 1 month
    now.setTime(expireTime);
    cookieStr += 'expires='+now.toUTCString(); // set country as checked
  }
  document.cookie = cookieStr;
}

function closeCountrySwitchPopup(askAgain) {
  // document.getElementById('country-switch-popup').style.display = 'none';
  setCountryCookie(askAgain);
  toggleCountryPop()
}

document.querySelectorAll('.js-country-link-btn').forEach(element => {
  element.addEventListener('click', e => {
  e.preventDefault();
  console.log('click')
  //keep selected filters active when switching langs
  if(typeof search !== 'undefined'){
    search.renderState[indexName].clearRefinements.refine();
  }

  var languageCode = document.getElementById('form_language_code').value;

  var currentUrl = window.location.href;
  var newUrl = currentUrl.replace(/(\.com)(\/|$)/, `$1/${languageCode}/`);
  window.location.href = newUrl;

  console.log(languageCode)
  var cookieStr = hasSelectedLang + '='+languageCode+ ';';
  document.cookie = cookieStr;


    // var countryCode = element.getAttribute('country');
    // document.getElementById('form_country_code').value = countryCode;

    document.getElementById('localization_form').submit();

    setCountryCookie(true);
  });
});

document.querySelectorAll('.js-close-country-switch-popup').forEach(element => {
  element.addEventListener('click', e => {
    e.stopPropagation();
    closeCountrySwitchPopup(true);
  });
});

document.querySelectorAll('.js-close-country-switch-popup-and-stop-asking').forEach(element => {
  element.addEventListener('click', e => {
    e.stopPropagation();
    closeCountrySwitchPopup(false);
  });
});

document.getElementById('form_country_code').addEventListener('change', e => {
  setLangOptions(e.target.value);
  document.getElementById('form_language_code').selectedIndex = 0;
})
// document.querySelectorAll('.js-close-country-switch-popup-box').forEach(element => {
//   element.addEventListener('click', e => {
//     e.stopPropagation();
//   });
// });

